<h1 mat-dialog-title>
  <div [style.font-size.px]="media.isActive('lt-sm') ? '16' : ''">
    {{ 'LABEL_FILTER' | translate }}
  </div>
</h1>

<div mat-dialog-content fxLayout="column" fxAlign="center center">
  <div fxLayout="column" fxLayoutGap="20px">
    <form
      [formGroup]="formGroup"
      novalidate
      autocomplete="off"
      autocorrect="off"
    >
      <!-- level -->
      <mat-form-field class="width-100">
        <input
          matInput
          required
          #levelInput
          formControlName="level"
          [matAutocomplete]="levelAC"
          [placeholder]="'LABEL_LEVEL' | translate"
          (focus)="!levelAC.isOpen && getInitialData('level')"
        />

        <mat-icon
          matSuffix
          color="primary"
          class="clear-input"
          svgIcon="close-circle"
          *ngIf="levelInput.value"
          (click)="resetControl(formGroup.get('level')); levelInput.value = ''"
        >
        </mat-icon>

        <mat-autocomplete
          [displayWith]="displayFn"
          #levelAC="matAutocomplete"
          (closed)="levelInput.blur()"
        >
          <mat-option *ngFor="let item of levels" [value]="item">
            {{ item.description }}
          </mat-option>
        </mat-autocomplete>

        <mat-icon
          matSuffix
          class="clear-input"
          svgIcon="menu-down"
          *ngIf="!levelInput.value"
        >
        </mat-icon>

        <mat-error *ngIf="formGroup.controls['level'].hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>

        <mat-error *ngIf="formGroup.controls['level'].hasError('notExisting')">
          {{
            'MSG_DOESNT_EXIST'
              | translate : { type: ('LABEL_CAMPAIGN' | translate) }
          }}
        </mat-error>
      </mat-form-field>

      <!-- campaign -->
      <mat-form-field class="width-100">
        <input
          matInput
          required
          #campaignInput
          formControlName="campaign"
          [matAutocomplete]="campaignAC"
          [placeholder]="'LABEL_CAMPAIGN' | translate"
          (focus)="!campaignAC.isOpen && getInitialData('campaign')"
        />

        <mat-icon
          matSuffix
          color="primary"
          class="clear-input"
          svgIcon="close-circle"
          *ngIf="campaignInput.value"
          (click)="
            resetControl(formGroup.get('campaign')); campaignInput.value = ''
          "
        >
        </mat-icon>

        <mat-icon
          matSuffix
          class="clear-input"
          svgIcon="menu-down"
          *ngIf="!campaignInput.value"
        >
        </mat-icon>

        <mat-autocomplete
          [displayWith]="displayFn"
          #campaignAC="matAutocomplete"
          (closed)="campaignInput.blur()"
          (opened)="
            autocompleteScroll('campaign', 'campaignACRef', 'campaignACTr')
          "
        >
          <mat-option
            disabled
            *ngIf="!loading.campaign && campaigns?.length == 0"
          >
            {{ 'MSG_NO_DATA' | translate }}
          </mat-option>

          <mat-option *ngFor="let item of campaigns" [value]="item">
            {{ item.description }}
          </mat-option>

          <mat-option *ngIf="loading.campaign" disabled>
            <mat-spinner
              color="primary"
              class="spinner-margin-auto"
              [diameter]="45"
            ></mat-spinner>
          </mat-option>
        </mat-autocomplete>

        <mat-error *ngIf="formGroup.controls['campaign'].hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>

        <mat-error
          *ngIf="formGroup.controls['campaign'].hasError('notExisting')"
        >
          {{
            'MSG_DOESNT_EXIST'
              | translate : { type: ('LABEL_CAMPAIGN' | translate) }
          }}
        </mat-error>
      </mat-form-field>

      <!-- distribution -->
      <mat-form-field class="width-100">
        <input
          matInput
          required
          #distributionInput
          formControlName="distribution"
          [matAutocomplete]="distributionAC"
          [placeholder]="'LABEL_DISTRIBUTION' | translate"
          (focus)="!distributionAC.isOpen && getInitialData('distribution')"
        />

        <mat-icon
          matSuffix
          color="primary"
          class="clear-input"
          svgIcon="close-circle"
          *ngIf="distributionInput.value"
          (click)="
            resetControl(formGroup.get('distribution')); distribution.value = ''
          "
        >
        </mat-icon>

        <mat-icon
          matSuffix
          class="clear-input"
          svgIcon="menu-down"
          *ngIf="!distributionInput.value"
        >
        </mat-icon>

        <mat-autocomplete
          [displayWith]="displayFn"
          #distributionAC="matAutocomplete"
          (closed)="distributionInput.blur()"
          (opened)="
            autocompleteScroll(
              'distribution',
              'distributionACRef',
              'distributionACTr'
            )
          "
        >
          <mat-option
            disabled
            *ngIf="!loading.distribution && distributions?.length == 0"
          >
            {{ 'MSG_NO_DATA' | translate }}
          </mat-option>

          <mat-option *ngFor="let item of distributions" [value]="item">
            {{ item.description }}
          </mat-option>

          <mat-option *ngIf="loading.distribution" disabled>
            <mat-spinner
              color="primary"
              class="spinner-margin-auto"
              [diameter]="45"
            ></mat-spinner>
          </mat-option>
        </mat-autocomplete>

        <mat-error
          *ngIf="formGroup.controls['distribution'].hasError('required')"
        >
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>

        <mat-error
          *ngIf="formGroup.controls['distribution'].hasError('notExisting')"
        >
          {{
            'MSG_DOESNT_EXIST'
              | translate : { type: ('LABEL_DISTRIBUTION' | translate) }
          }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>
</div>

<div
  mat-dialog-actions
  *ngIf="!media.isActive('lt-sm')"
  fxLayout
  fxLayoutAlign="end center"
>
  <button type="button" color="primary" mat-button (click)="applyFilters()">
    {{ 'LABEL_APPLY' | translate }}
  </button>
  <button type="button" color="warn" mat-button (click)="reset()">
    {{ 'LABEL_RESET' | translate }}
  </button>
</div>

<!-- buttons for mobile view -->
<div
  mat-dialog-actions
  *ngIf="media.isActive('lt-sm')"
  fxLayout
  fxLayoutAlign="end center"
>
  <button
    type="button"
    color="primary"
    mat-icon-button
    (click)="applyFilters()"
  >
    <mat-icon svgIcon="check"></mat-icon>
  </button>

  <button type="button" color="warn" mat-icon-button (click)="reset()">
    <mat-icon svgIcon="restore"></mat-icon>
  </button>
</div>
